import { render, staticRenderFns } from "./PagoSimpatizanteSgaComponent.vue?vue&type=template&id=e0fb417e"
import script from "./PagoSimpatizanteSgaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PagoSimpatizanteSgaComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports